import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

import personalSituationCircles from "./subscriptions/PersonalSituationCircles"
application.register("personal-situation", personalSituationCircles)
import newSubscription from "./subscriptions/NewSubscription"
application.register("new-subscription", newSubscription)
import enableFormSubmit from "./enableFormSubmit"
application.register("enable-form-submit", enableFormSubmit)
